import { Location } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  inject,
} from '@angular/core';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
  standalone: false,
})
export class PaginatorComponent implements OnInit {
  location = inject(Location);

  @Input() pageIndex: number = 1;
  @Input() totalCount: number = 0;
  @Input() totalPages: number = 0;
  @Input() hasPreviousPage: boolean;
  @Input() hasNextPage: boolean;
  @Input() hidePageSize: boolean;
  @Input() loading: boolean;
  @Input() pageSizes: number[] = [];
  @Input() clearFilters: boolean = true;
  @Input() ignoreDisableBtn: boolean = false;

  @Output() pageSize = new EventEmitter<number>();
  @Output() pageNumber = new EventEmitter<number>();
  @Output() deselectAll = new EventEmitter<boolean>();

  defaultPageSize: number = 30;

  constructor() {}

  ngOnInit() {
    if (!this.pageSizes) this.pageSizes = [30, 40, 50, 60, 80, 100, 200];

    const urlObj = new URL(window.location.href);
    const url = new URLSearchParams(urlObj.search);
    for (const [key, value] of url.entries()) {
      if (key == 'PageSize' && !isNaN(+value)) {
        this.defaultPageSize = +value;
        if (+value > 200) {
          this.defaultPageSize = 200;
          const reg = /PageSize=[0-9]+/;
          this.location.go(
            window.location.pathname +
              window.location.search.replace(reg, 'PageSize=200')
          );
        }
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['clearFilters']) {
      this.pageIndex = 1;
      this.defaultPageSize = 30;
    }
  }

  nextPage() {
    if (
      (this.hasNextPage && this.pageIndex < this.totalPages) ||
      this.ignoreDisableBtn
    ) {
      this.emitDeselectAll();
      this.pageIndex++;
      this.emitPageNumber(this.pageIndex);
    }
  }

  previousPage() {
    if (this.hasPreviousPage && this.pageIndex > 1) {
      this.emitDeselectAll();
      this.pageIndex--;
      this.emitPageNumber(this.pageIndex);
    }
  }

  firstPage() {
    this.emitDeselectAll();
    this.pageIndex = 1;

    this.emitPageNumber(this.pageIndex);
  }

  lastPage() {
    this.emitDeselectAll();
    this.pageIndex = this.totalPages;
    this.emitPageNumber(this.pageIndex);
  }

  emitPageSize(pageSize) {
    this.defaultPageSize = +pageSize;
    this.emitDeselectAll();
    if (pageSize > this.totalCount) {
      this.emitPageNumber(1);
    }
    this.pageSize.emit(pageSize);
  }

  emitPageNumber(pageNumber) {
    this.emitDeselectAll();
    if (pageNumber > this.totalPages) {
      this.totalPages == 0
        ? (this.pageIndex = 1)
        : (this.pageIndex = this.totalPages);

      this.pageNumber.emit(this.pageIndex);
      return;
    }
    if (pageNumber < 1) {
      this.pageIndex = 1;
      this.pageNumber.emit(this.pageIndex);
      return;
    }
    this.pageNumber.emit(pageNumber);
  }

  emitDeselectAll() {
    this.deselectAll.emit(false);
  }
}
